module.exports = __webpack_public_path__ + "20250828d091945t/img/newhands-icon.2d9c01eb.png";